/* eslint-disable import/prefer-default-export */

export const actions = {
  TEMPLATES_TOGGLE_SHOW_INFO_MODAL: 'TEMPLATES_TOGGLE_SHOW_INFO_MODAL',
  templatesShowInfoModal: () => ({
    type: actions.TEMPLATES_TOGGLE_SHOW_INFO_MODAL,
  }),
};
